import { render, staticRenderFns } from "./InactiveEmpty.vue?vue&type=template&id=3cb90f43&scoped=true"
import script from "./InactiveEmpty.vue?vue&type=script&lang=js"
export * from "./InactiveEmpty.vue?vue&type=script&lang=js"
import style0 from "./InactiveEmpty.vue?vue&type=style&index=0&id=3cb90f43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb90f43",
  null
  
)

export default component.exports